"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const lodash_1 = require("lodash");
class Tag {
    constructor({ children, attributes = {}, name, }) {
        this.name = name;
        this.attributes = attributes;
        this.children = children;
    }
    addAttr(attr = {}) {
        var _a;
        this.attributes = Object.assign((_a = this.attributes) !== null && _a !== void 0 ? _a : {}, attr);
    }
    attrs() {
        var _a, _b, _c;
        if (Object.keys((_a = this.attributes) !== null && _a !== void 0 ? _a : {}).length > 0) {
            return ' '
                .concat(Object.keys((_b = this.attributes) !== null && _b !== void 0 ? _b : {})
                .filter((key) => key != 'dataset')
                .map((key) => {
                var _a, _b, _c;
                return `${key == 'className' ? 'class' : key}="${typeof ((_a = this.attributes) !== null && _a !== void 0 ? _a : {})[key] == 'object'
                    ? Tag.objectToSting(((_b = this.attributes) !== null && _b !== void 0 ? _b : {})[key], {
                        separator: key == 'style' ? ';' : ',',
                        fnKey: key == 'style' ? lodash_1.kebabCase : undefined,
                    })
                    : ((_c = this.attributes) !== null && _c !== void 0 ? _c : {})[key]}"`;
            })
                .join(' '))
                .concat(Object.keys((_c = this.attributes) !== null && _c !== void 0 ? _c : {})
                .filter((key) => key == 'dataset')
                .map((key) => {
                var _a;
                const dataset = ((_a = this.attributes) !== null && _a !== void 0 ? _a : {})[key];
                if (typeof dataset != 'object')
                    return '';
                return Object.keys(dataset)
                    .map((dataKey) => {
                    const value = dataset[dataKey];
                    if (/^data.*$/.test(dataKey))
                        return `${(0, lodash_1.kebabCase)(dataKey)}="${value}"`;
                    else
                        `data-${dataKey}="${value}"`;
                })
                    .join(' ');
            })
                .join(' '));
        }
        return '';
    }
    toString() {
        if (Array.isArray(this.children)) {
            return `
        ${this.name === 'html' ? '<!DOCTYPE html>' : ''}
        <${this.name}${this.attrs()}>${this.children.join('')}</${this.name}>
      `;
        }
        if (this.children === undefined || this.children === null) {
            return `<${this.name}${this.attrs()} />`;
        }
        return `<${this.name}${this.attrs()}>${this.children}</${this.name}>\r\n`;
    }
    static objectToSting(obj, options = { separator: ',' }) {
        return Object.keys(obj)
            .map((oldKey) => {
            let key = oldKey;
            let value = obj[key];
            if (key == 'className')
                key = 'class';
            if (options.fnKey)
                key = options.fnKey(key);
            if (options.fnValue)
                value = options.fnValue(value == undefined ? '' : String(value));
            return `${key}: ${value}`;
        })
            .join(options.separator);
    }
}
exports.Tag = Tag;
